import React, { useState, useEffect } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import ReactTable from 'components/ReactTable/ReactTable';
import Button from 'components/CustomButtons/Button';
import { Visibility } from '@material-ui/icons';
import { wsGetAll } from 'services/WService';
import { Link } from 'react-router-dom';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 125 },
  { Header: 'Nombre', accessor: 'name' },
  { Header: 'Usuarios suscritos', accessor: 'users_count', width: 200 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function NotificationList() {
  const [notifications, setNotifications] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listNotifications() {
    setDataLoading(true);
    let res = await wsGetAll('mail/notification');
    setNotifications(res.data);
    setDataLoading(false);
  }

  useEffect(() => {
    listNotifications();
  }, []);

  return (
    <CardContainer /*title="Listado de notificaciones"*/ title={(<>Listado de notificaciones {dataLoading && <LoadingSpinner />}</>)}>
      <ReactTable
        columns={columns}
        data={notifications.map((notification, index) => {
          return {
            ...notification,
            num: (
              <div className="actions-right">
                {index + 1}
                <Link to={`${notification.id}`}>
                  <Button justIcon round simple color="primary" className="like">
                    <Visibility />
                  </Button>
                </Link>
              </div>
            ),
          };
        })}
        exportExcel={false}
      />
    </CardContainer>
  );
}

export default NotificationList;
